import axios, { fetchWithAuthToken } from '../../axios';
import { showError, showInfo, showSuccess } from '../../js/ui-helpers';

const state = () => ({
    renewableEnergyTechInfo: {title: '...loading', items: []},
    physicalInfrastructrueInfo: {title: '...loading', items: []},
    landuseInfo: {title: '...loading', items: []},
    populationInfo: {title: '...loading', items: []},
    populationChartData: {title: {text: '...loading'}, xAxis: {}, yAxis: {}, series: [],},
    selectedRegion: 'all provinces',
    energyCharts: [],
    energyCSVURI: "",
    cookingImprovementData: null,
});

const getters = {
    getRenewableEnergyTechInfo: state => state.renewableEnergyTechInfo,
    getPhysicalInfrastructureInfo: state => state.physicalInfrastructrueInfo,
    getLanduseInfo: state => state.landuseInfo,
    getPopulationChartData: state => state.populationChartData,
    getPopulationInfo: state => state.populationInfo,
    getEnergyChartsData: state => state.energyCharts,
    getEnergyCSVURI: state => state.energyCSVURI,
    getSelectedRegion: state => state.selectedRegion,
    getCookingImprovementData: state => state.cookingImprovementData,
};

const actions = {
    updateSelectRegion({commit}, region)
    {
        commit('SET_SElECTED_REGION', region);
    },
    async _fetchPopulationData({commit, state} , adminid)
    {
        const years = [2011, 2016, 2021, 2026, 2031];
        const data = {};
        try
        {
            const response = await axios(`api/dds4dev/data/?year=2016&variableid=11&adminid=${adminid}`)
            const {male, female, total} = response.data.chart.areachart;
            data.male = male.map(Math.floor);
            data.female = female.map(Math.floor);
            data.total = total.map(Math.floor);
        }
        catch (error)
        {
            data.male = data.female = data.total = Array(5).fill(-1);
            showError(
                `${state.selectedRegion} Population data`,
                `Failed loading population data of ${state.selectedRegion}`
            );
        }
        finally
        {
            commit('SET_POP_CHART_DATA', {...data, years});
            commit('SET_POP_INFO', {title: 'Population Statistics', ...data, years});
        }
    },
    async _fetchOtherInfographicsData({commit, state}, adminid)
    {
        try
        {
            const { data } = await fetchWithAuthToken(`api/infographics/${adminid}`);
            commit('SET_LANDUSE_INFO', data['Landuse Status']);
            commit('SET_INFRASTRUCTURE_INFO', data['Physical Infrastructrue']);
            commit('SET_RENEWABLE_TECH_INFO', data['Renewable Energy Technology']);
        }
        catch (error)
        {
            commit('SET_LANDUSE_INFO', []);
            commit('SET_INFRASTRUCTURE_INFO', []);
            commit('SET_RENEWABLE_TECH_INFO', []);
            showError(
                `${state.selectedRegion} Infographics data`,
                `Failed loading infographics data of ${state.selectedRegion}`
            );
        }
    },
    async _fetchODKEnergyData({state}, sddmm)
    {
        try
        {
            const result = await fetchWithAuthToken(`api/odk-energy-data/?sddmm=${sddmm}`);
            return result.data;
        }
        catch ({response})
        {
            if (!response || response.status!==404)
            {
                showError(`${state.selectedRegion} Energy data`, "Error loading energy data in ODK database")
            }
        }
    },
    async _fetchMEPEnergyData({state}, sddmm)
    {
        try
        {
            const result = await fetchWithAuthToken(`api/mep-energy-data/?sddmm=${sddmm}`);
            return result.data;
        }
        catch ({response})
        {
            if (!response || response.status!==404)
            {
                showError(
                    `${state.selectedRegion} Energy data`,
                    `Failed loading energy data of ${state.selectedRegion}`
                );
            }
        }
    },
    async _fetchMunEnergyData({state, commit}, sddmm)
    {
        let data = await this.dispatch('infographics/_fetchODKEnergyData', sddmm) ||
            await this.dispatch('infographics/_fetchMEPEnergyData', sddmm);

        const msgTitle = `${state.selectedRegion} Energy data`;
        if (data)
        {
            commit('SET_ENERGY_CHARTS_DATA', data.charts);
            commit('SET_ENERGY_CSV_URI', data.csv);
            commit('SET_COOKING_IMPROVEMENT_DATA', data.cookingImprovementData && data.cookingImprovementData.data);
            showSuccess(msgTitle, `Successfully loaded energy data for ${state.selectedRegion} municipality`)
        }
        else
        {
            this.dispatch('infographics/_resetMunEnergyData');
            showInfo(msgTitle, `Energy data for ${state.selectedRegion} is unavailable`)
        }
    },
    async _resetMunEnergyData({commit})
    {
        commit('SET_ENERGY_CHARTS_DATA', []);
        commit('SET_ENERGY_CSV_URI', "");
        commit('SET_COOKING_IMPROVEMENT_DATA', null);
    },
    async fetchInfographicsData(_, {adminid, isMunicipality=false})
    {
        if (this.getters.isDashboardMode)
        {
            await Promise.all([
                this.dispatch('infographics/_fetchPopulationData', adminid),
                this.dispatch('infographics/_fetchOtherInfographicsData', adminid),
                isMunicipality ?
                this.dispatch('infographics/_fetchMunEnergyData', adminid)
                :
                this.dispatch('infographics/_resetMunEnergyData'),
            ]);
        }
    },
};


const mutations = {
    SET_RENEWABLE_TECH_INFO: (state, data) =>
    {
        state.renewableEnergyTechInfo = {
            id: 'renewable-tech-infographics',
            title: 'Renewable Energy Technology',
            items: data,
        };
    },
    SET_SElECTED_REGION: (state, region) => {
        state.selectedRegion = region;
    },
    SET_INFRASTRUCTURE_INFO: (state, data) =>
    {
        state.physicalInfrastructrueInfo = {
            id: 'infastructrue-infographics',
            title: 'Physical Infrastructrue',
            items: data
        };
    },
    SET_LANDUSE_INFO: (state, data) =>
    {
        state.landuseInfo = {
            id: 'landuse-infographics',
            title: 'Landuse Status',
            items: data,
        }
    },
    SET_POP_CHART_DATA: (state, {female, male, years, total}) =>
    {
        state.populationChartData = {
            title: { text: 'Population trend by sex' },
            chart: { type: 'line' },
            xAxis: { categories: years },
            yAxis: { title: { text: "Population", } },
            series: [
                { name: "Female", data: female, color: "#23527A", },
                { name: "Male", data: male, color: "#7A4B23", },
                { name: "Total", data: total, color: "#333", visible: false, },
            ],
        };
    },
    SET_POP_INFO: (state, {title, years, male, female, total}) =>
    {
        state.populationInfo.title = title;
        state.populationInfo.items = years.map((year,index) =>
        ({
            'male': male[index],
            'female': female[index],
            'total': total[index],
            'year': year,
        }));
    },
    SET_ENERGY_CHARTS_DATA(state, chartsData)
    {
        state.energyCharts = chartsData;
    },
    SET_ENERGY_CSV_URI(state, csvData)
    {
        state.energyCSVURI = csvData;
    },
    SET_COOKING_IMPROVEMENT_DATA(state, data)
    {
        state.cookingImprovementData = data;
    }
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

//     // Figure 22: Overall Improvement Scenarios 
//     if (chartDivsHas('Fig22_Cooking_Improvement_Table')) 
//     {
//         // preparing percent data
//         const baselinePercents = chartDataList[15].Data.percentages;
//         // calculating partial scenario percentages
//         const partial_scenario = { ...baselinePercents }; // this will work we have no reference values
//         partial_scenario["Partial"] += partial_scenario["Low"];
//         partial_scenario["Low"] = 0;
//         // calculating intermediate scenario percentages
//         const inter_scenario = { ...partial_scenario }; // this will work we have no reference values
//         inter_scenario["Intermediate"] += inter_scenario["Partial"];
//         inter_scenario["Partial"] = 0;
//         // text input html string maker function
//         const textInput = (placeholder, costLabel, inputId, spanId) => `
//             <input 
//                 type="text" 
//                 id="${ inputId}"
//                 placeholder="${ placeholder}" 
//                 style="height: 20px; width:30%; display: inline-block; margin-left:8%"
//             >
//             <span>
//                 ${ costLabel} <span id="${spanId}" style="font-weight: bold;"></span>
//             </span><br/>`

//         // header part of table
//         let improvement_table = `
//         <style>
//             .improvement-table-title {
//                 font-family: Montserrat, Arial, sans-serif;
//                 font-weight: 600;
//                 margin-top: 2px;
//                 font-size: 14px; 
//                 text-align: center;
//             }
//             .table tbody tr th, .table tbody tr td {
//                 line-height: 0.4;
//             } 
//         </style>
//         <div class="improvement-table-title">
//             <span>Overall Improvement Scenarios(${ municipalityName })</span>
//         </div>
//         <div style="overflow: auto; font-size: 9px;">
//             <table class="table table-sm table-striped table-hover">
//                 <thead>
//                     <tr>
//                         <th scope="col">Primary Stove</th>
//                         <th scope="col">2018<br>(Baseline)</th>
//                         <th scope="col">Scenario: Partial</th>
//                         <th scope="col">Scenario: Intermediate</th>
//                     </tr>
//                 </thead>
//                 <tbody>`
//         // filling the table with rows
//         Object.keys(baselinePercents).forEach( category =>
//         {
//             improvement_table += `<tr>
//                 <th scope="row">${ category }</th>
//                 <td id="baseColumn-${ category }">${ baselinePercents[ category ] }%</td>
//                 <td id="partialColumn-${ category }">${ partial_scenario[ category ]  }%</td>
//                 <td id="interColumn-${ category }">${ inter_scenario[ category ] }%</td>
//             </tr>`
//         });
//         improvement_table += `</tbody></table>` // closing the table body and the table
//         // adding rate input
//         improvement_table += textInput('No of HH', '', 'nHouseholds-input','');
//         improvement_table += textInput('Cost Per HH', 'PARTIAL SCENARIO TOTAL COST: ', 'partial-rate-input','partial-price');
//         improvement_table += textInput('Cost Per HH', 'INTERMEDIATE SCENARIO TOTAL COST: ', 'inter-rate-input', 'inter-price');
//         // closing outer div
//         improvement_table += "</div>"
//         $('#Fig22_Cooking_Improvement_Table').html(improvement_table);

//         // adding calculation functionality for input change events
//         let nHouseholds_low         = 0;
//         let nHouseholds_low_partial = 0;
//         const updateTable = nHouseholds =>
//         {
//             Object.keys(baselinePercents).forEach(category => 
//             {
//                 const basePercent = baselinePercents[category];
//                 const partialPercent = partial_scenario[category];
//                 const interPercent = inter_scenario[category];
//                 const percentToCount = (percent, total) => Math.round(percent/100*total);
//                 $(`#baseColumn-${ category }`).text(`${ basePercent }%(${ percentToCount(basePercent, nHouseholds) })`);
//                 $(`#partialColumn-${ category }`).text(`${ partialPercent }%(${ percentToCount(basePercent, nHouseholds) })`);
//                 $(`#interColumn-${ category }`).text(`${ interPercent }%(${ percentToCount(basePercent, nHouseholds) })`);
//             });
//         };
//         const getPrice = (rate, numTotal) => "Rs. " + rate * numTotal;
//         $('#nHouseholds-input').change( event => 
//         {
//             const nHouseholds = event.target.value;
//             // updating nHouseholds_low and low_partial
//             nHouseholds_low = Math.round( nHouseholds * baselinePercents["Low"] / 100 );
//             nHouseholds_low_partial = Math.round( nHouseholds * partial_scenario["Partial"] / 100 );
//             // updating table
//             updateTable( nHouseholds );
//             // updating the prices
//             $('#partial-price').text( getPrice($('#partial-rate-input').val(), nHouseholds_low) );
//             $('#inter-price').text( getPrice($("#inter-rate-input").val(), nHouseholds_low_partial) );
//         });
//         $("#partial-rate-input").change(event => 
//         { 
//             $('#partial-price').text( getPrice(event.target.value, nHouseholds_low) );
//         });
//         $("#inter-rate-input").change(event => 
//         { 
//             $('#inter-price').text( getPrice(event.target.value, nHouseholds_low_partial) );
//         });
//     }
// }
